// extracted by mini-css-extract-plugin
export default {"triggerContainer":"CommonDropdown_triggerContainer__C5xHv","dropdown":"CommonDropdown_dropdown__vvO9m"};